import { InjectionToken } from '@angular/core';
import { CartRepository } from 'src/app/core/repositories/cart.repository';

export const cartRepositoryInjectionToken: InjectionToken<CartRepository> = new InjectionToken(
  'Cart Repository',
);
